export default __webpack_public_path__ + "static/media/Family Portrait.fe602ff2.jpg";